import * as React from 'react'
import { FC, useCallback } from 'react'
import { BillToMatchCardProps } from '../typings'
import { AppAvatar } from '@sales-center/components'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'

type Props = BillToMatchCardProps & {
  checked: boolean
}

export const Header: FC<Props> = (props) => {
  const { billTo, onSelectBillTo, checked } = props

  const select = useCallback(
    () => onSelectBillTo(billTo),
    [billTo, onSelectBillTo],
  )

  return (
    <Box display="flex" alignItems="center" mb={1}>
      <AppAvatar variant="contained" text="PP" />

      <Typography>PestPac Location</Typography>

      <div style={{ flexGrow: 1 }} />

      <FormControlLabel
        label="Match Bill-to"
        style={{ margin: 0 }}
        control={<Radio checked={checked} onChange={select} />}
      />
    </Box>
  )
}
Header.displayName = 'Header'
